<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
// import logo from '@/assets/logo.png'

export default {
  name: 'BlankLayout',
  data () {
    return {
    }
  }
}
</script>
